// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { convertDDtoDMSPref } from 'helpers/coordsConversion'

const scrubPassiveData = ({ segments }) => {
  const lastSegment = segments.length - 1

  return segments.reduce((a, d, i) => {
    // we captured the last passive in the previous loop
    if (i === lastSegment) {
      return a
    }

    const ps = d.segmentEnds[1]

    const { siteName } = ps

    const antennas = ps.segmentEndAntennas.map(ant => ({
      antennaCode: ant.antennaCode,
      modelNumber: ant.modelNumber,
    }))

    // Gets the antennas from both segment ends which make up this passive repeater.
    // NOTE - this does not care about back-to-back vs billboard.
    // The query does not include that detail.
    // So this will always show two antennas for a passive repeater,
    // even on billboards, from the two segmentEnds that make up the passive.
    segments[i + 1].segmentEnds[0].segmentEndAntennas.forEach(ant => {
      antennas.push({
        antennaCode: ant.antennaCode,
        modelNumber: ant.modelNumber,
      })
    })

    const latitude = convertDDtoDMSPref(ps.latitude, 'latitude')
    const longitude = convertDDtoDMSPref(ps.longitude, 'longitude')

    a.push({
      antennas,
      latitude,
      longitude,
      siteName,
    })

    return a
  }, [])
}

export default scrubPassiveData
